// extracted by mini-css-extract-plugin
export default {"danger":"CMFqKV"};